import { actionTypes } from './constants';

export const setEnergyViewMode = (viewMode) => ({
    type: actionTypes.SET_ENERGY_VIEW_MODE,
    payload: viewMode
});
